import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SpecialCompbaser } from "../../../components/compbaser";
import {
    ExperienceLevelType,
    IAccessTable,
    IAppSettingsWrap,
    Id,
    IEffectTypeAny,
    IPlayerProps,
    IResource,
    ISceneItemPosition,
    ISceneTreeSliceResults,
    ISelectedSceneSceneId,
    IUser,
} from "../../../interfaces";
import { actionSceneBreadcrumbsClear, actionSceneJumpLinked, actionSelectedSceneId, actionSelectedSceneItemId, actionSetEditorMode, actionUpdateSceneItem } from "../../../store/actions/user.actions";
import { BlockLabels, IAdvancedEvents, IBlockLabelProp } from "../scene-blocks/block-constants";
import { compareIds, convertBooleanToNumbers, convertNumberToBoolean, isHostDevOrLocal, isMimeTypeExists, isTruthy, mimeSwap, shortenString } from "../../../common";
import {
    faAnchor,
    faBell,
    faCode,
    faCube,
    faHdd,
    faObjectUngroup,
    faPlane,
    faPlugCircleCheck,
    faRandom,
    faReceipt,
    faRightFromBracket,
    faRobot,
    faWrench,
    IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { getFontIcons } from "../../../common/get-icons";
import { Title } from "@angular/platform-browser";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { AccessService, ContainerService, LocalStoreService, StoreSelectorsService } from "../../../services";
import { TranslocoService } from "@ngneat/transloco";
import { filter, map, mergeMap } from "rxjs/operators";
import { combineLatest, of } from "rxjs";
import { MatTabGroup } from "@angular/material/tabs";
import { MatDrawer, MatDrawerContainer } from "@angular/material/sidenav";
import { SceneMimeTypes } from "../scene-blocks/mime-constants";
import { AiService } from "../../../services/ai/ai.service";
import * as _ from "lodash";

export type ITimelineViewMode = "animationMode" | "playlistMode" | "collectionMode" | "locationMode";

@Component({
    selector: "app-editor-editor",
    templateUrl: "./scene-editor.component.html",
    styleUrls: ["./scene-editor.component.scss"],
    animations: [
        trigger("fadeProperty", [
            state("void, hidden", style({ opacity: 0 })),
            state("visible", style({ opacity: 1 })),
            transition("* => visible", animate("1500ms cubic-bezier(0.0, 0.0, 0.2, 1)")),
            transition("* => hidden", animate("77ms cubic-bezier(0.4, 0.0, 1, 1)")),
        ]),
    ],
    standalone: false,
})
export class SceneEditorComponent extends SpecialCompbaser implements OnInit {
    @ViewChild("detailsTemplate", { static: true }) detailsTemplate!: TemplateRef<any>;
    @ViewChild("animationTemplate", { static: true }) animationTemplate!: TemplateRef<any>;
    @ViewChild("effectsTemplate", { static: true }) effectsTemplate!: TemplateRef<any>;

    @ViewChild("tabGroupAnimation") tabGroupAnimation: MatTabGroup;
    @ViewChild("sidenav") sidenav: MatDrawer;

    @ViewChild(MatDrawerContainer) drawerContainer!: MatDrawerContainer;

    readonly faWrench = faWrench;
    readonly faAnchor = faAnchor;
    readonly faPlugCircleCheck = faPlugCircleCheck;
    readonly faRandom = faRandom;
    readonly faObjectUngroup = faObjectUngroup;
    readonly faHdd = faHdd;
    readonly faCode = faCode;
    readonly faReceipt = faReceipt;
    readonly faBell = faBell;
    readonly faCube = faCube;
    readonly faRightFromBracket = faRightFromBracket;

    minimized = false;
    activeTemplate = "details";

    sceneItems: ISceneItemPosition[] = [];
    totalItemsAdded = 0;
    propertiesWidth = "285px";
    transitionExist = false;
    selectItemIndex = -1;
    propsMinimized = false;

    isHostDevOrLocal = false;
    panelOpenState = true;
    renderSceneContainer = false;
    selectedSceneId;
    showEffects = true;
    selectedSceneItemId: Id = "";
    blockName = "";
    showEvents = true;
    showPop: boolean = null;
    isBlockTransition = false;
    isBlockAdvEvents: IAdvancedEvents = null;
    isBlockAnimation = false;
    isDataProvider = false;
    sceneData: IPlayerProps;
    resources: IResource[] = [];
    isSceneButNotNested = false;
    isNotNested = true;
    transitionsEnabled = false;
    // isAnchorSupport = false;
    sceneSlice: ISceneTreeSliceResults;
    blockJsonBased = false;
    blockIcon: IconDefinition;
    blockMimeName = "";
    blockVideoLinkName = "";
    videoHelp = false;
    isPlayerAssignable = false;
    ind = 1;
    visibility = "visible";
    viewMode: ITimelineViewMode;
    coreAppData: IAppSettingsWrap;
    user: IUser;
    accessConfig: IAccessTable;
    activeTabIndex = 1;
    multiple = false;
    scriptingMode = false;
    isFullFeatures;
    sceneMime = "";
    activeIds = [];

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    constructor(
        private title: Title,
        private route: ActivatedRoute,
        private localStoreService: LocalStoreService,
        private containerService: ContainerService,
        private storeSelector: StoreSelectorsService,
        private accessService: AccessService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private aiService: AiService,
    ) {
        super();
    }

    ngOnInit() {
        // Set editor mode to scene-builder (regular scene editor)
        this.storeSelector.dispatch(actionSetEditorMode({ editorMode: "scene-builder" }));

        this.setSceneOpacity();
        this.isHostDevOrLocal = isHostDevOrLocal();
        this.scriptingMode = isTruthy(this.localStoreService.getStorageValConfig("scriptingMode"));
        this.transitionsEnabled = convertNumberToBoolean(this.localStoreService.getStorageValConfig("transitionsEnabled"));

        this.cod(
            this.storeSelector.getLocalStoreUpdates("ILocalStorageConfig").subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
            }),
        );

        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            }),
        );
        this.cod(
            this.storeSelector.getResources().subscribe((i_resources) => {
                this.resources = i_resources;
            }),
        );
        this.cod(
            this.storeSelector.getUser().subscribe((i_user: IUser) => {
                this.user = i_user;
            }),
        );
        this.cod(this.storeSelector.getCoreData().subscribe((i_coreData: IAppSettingsWrap) => (this.coreAppData = i_coreData)));

        // this.cod(
        //     this.storeSelector.getScenes().subscribe((i_scenes) => {
        //         this.scenes = i_scenes;
        //     })
        // );
        // this.cod(
        //     this.route.paramMap.subscribe((routeParams) => {
        //         this.selectedSceneId = routeParams.get('id');
        //     })
        // );

        this.cod(
            this.storeSelector.listenSelectedSceneItemId().subscribe((value) => {
                this.selectedSceneItemId = value;
                this.visibility = "hidden";
            }),
        );
        this.cod(
            this.storeSelector.listenPlayerDataOfSelectedSceneItemId().subscribe((i_sceneSlice: ISceneTreeSliceResults) => {
                this.sceneSlice = i_sceneSlice;
                this.blockName = this.sceneSlice.sceneItem.$.label;
                if (compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.BLOCKCODE_SCENE.id)) {
                    this.blockName = "scene";
                } else {
                    this.blockName = !!this.blockName ? this.blockName.toString() : "";
                    this.blockName = shortenString(this.blockName.toLocaleLowerCase(), 30);
                }
                this.showEffects = !(compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.MUSICLIST.id) || compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.MUSIC.id));
                const sceneBlock = this.storeSelector.getBlockLabelById(this.sceneSlice.sceneItem.$.player);
                this.showEvents = false;
                if (!sceneBlock) return;
                this.showEvents = sceneBlock.advEvents.send === true || sceneBlock.advEvents.receive === true || sceneBlock.advEvents.filter === true || sceneBlock.advEvents.source === true;
                const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneSlice.sceneItem);
                const blockLabelProps: IBlockLabelProp = this.storeSelector.getBlockLabelById(playerId);
                this.isDataProvider = blockLabelProps.dataProviderBlock && blockLabelProps.dataProviderBlock === true;
                this.isSceneButNotNested = this.blockName === "scene" && !this.sceneSlice.sceneItem.$.src;
                this.isNotNested = this.blockName === "scene" ? this.isSceneButNotNested : true;
                this.isPlayerAssignable = this.isSceneButNotNested && this.sceneSlice.sceneItem.$?.mimeType === SceneMimeTypes.Player;
                this.isBlockTransition = sceneBlock.transitions;
                this.isBlockAnimation = sceneBlock.animation;
                this.isBlockAdvEvents = sceneBlock.advEvents;
                this.showPop = sceneBlock.pop;
                // this.isAnchorSupport = sceneBlock.anchor;

                this.setTitle();
                this.assignIcon(playerId, sceneBlock.types, sceneBlock.jsonItemBased);
                this.setBlockJsonBased();
            }),
        );

        this.cod(
            this.storeSelector
                .listenSelectedSceneIdAndSceneItemId()
                .pipe(
                    mergeMap((v: ISelectedSceneSceneId) => {
                        /** improve performance, if sceneMime is already set no need to check again **/
                        if (this.sceneMime) {
                            return of(null);
                        } else {
                            return this.storeSelector.getSceneMimeType(v.sceneId);
                        }
                    }),
                )
                .subscribe((v) => {
                    if (!v) return;
                    this.sceneMime = v;
                }),
        );

        this.cod(
            combineLatest([this.route.paramMap, this.storeSelector.listenScenes()])
                .pipe(
                    map(([routeParams, i_scenes]) => {
                        return i_scenes.find((i_scene: IPlayerProps) => {
                            if (i_scene.Player.$.id === routeParams.get("id")) {
                                return true;
                            }
                        });
                    }),
                )
                .subscribe((i_scene: IPlayerProps) => {
                    if (!i_scene) return;
                    this.sceneData = i_scene;
                    if (this.selectedSceneId && this.selectedSceneId != i_scene.Player.$.id) {
                        this.renderSceneContainer = false;
                        this.cd.detectChanges();

                        setTimeout(() => {
                            this.updateSelectedScene(i_scene.Player.$.id);
                        }, 1000);
                    } else {
                        this.updateSelectedScene(i_scene.Player.$.id);
                    }
                }),
        );
        this.cod(
            this.containerService.editorMode.subscribe((mode: ITimelineViewMode) => {
                if ((mode == "playlistMode" || mode == "collectionMode") && this.selectedSceneItemId) {
                    this.containerService.playlist = {
                        sceneId: this.selectedSceneId,
                        selectedPlaylistId: this.selectedSceneItemId,
                    };
                    this.viewMode = mode;
                } else if (mode == "locationMode" && this.selectedSceneItemId) {
                    this.viewMode = mode;
                } else {
                    if (this.viewMode) {
                        // this.activeTabIndex = 2;
                    }
                    this.viewMode = null;
                }
            }),
        );
        this.cod(
            this.accessService.getGroupsTable("SignStudio Editor", "player_data").subscribe((v) => {
                this.accessConfig = v;
            }),
        );
        this.cod(
            this.containerService.getActiveSceneItemIds().subscribe((v) => {
                if (v && v.length > 1) {
                    this.multiple = true;
                    this.activeIds = v;
                    if (this.activeTabIndex == 3) {
                        // this.activeTabIndex = 2;
                    }
                } else {
                    this.multiple = false;
                    this.activeIds = [this.selectedSceneId];
                }
            }),
        );

        this.cod(
            this.aiService.selectPropertyPage$.subscribe((propertyPage) => {
                this.setActiveTemplate(propertyPage);
            }),
        );
    }

    onNavMaximized() {
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 200);
    }

    onNavMinimized(event) {
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 0);
    }

    private updateSelectedScene(newSceneId) {
        this.selectedSceneId = newSceneId;
        this.renderSceneContainer = true;
        this.storeSelector.dispatch(actionSelectedSceneId({ id: this.selectedSceneId }));
        this.cd.detectChanges();
    }

    private setSceneOpacity() {
        const sceneOpacityLevel = this.localStoreService.getStorageValConfig("sceneOpacityLevel") / 100;
        const sceneGuidelinesOpacityLevel = this.localStoreService.getStorageValConfig("sceneGuidelinesOpacityLevel") / 100;
        document.documentElement.style.setProperty("--scene-opacity", String(sceneOpacityLevel));
        document.documentElement.style.setProperty("--guidelines-opacity", String(sceneGuidelinesOpacityLevel));
    }

    private setTitle(i_default?) {
        if (i_default) return this.title.setTitle("SignStudio");
        if (compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.BLOCKCODE_SCENE.id)) {
            const title = this.sceneSlice.sceneItem.$.label;
            let mime = this.sceneSlice.sceneItem.$.mimeType ? mimeSwap("longToShort", this.sceneSlice.sceneItem.$.mimeType) : "editor";
            if (!mime) mime = "custom";
            this.title.setTitle(`${title} | ${mime}`);
        }
    }

    assignIcon(i_blockPlayerId, sceneItemMimeType, isBlockItemBased) {
        if (sceneItemMimeType && isBlockItemBased && sceneItemMimeType?.length > 0 && isMimeTypeExists(sceneItemMimeType, this.sceneMime)) {
            this.blockIcon = getFontIcons({ $: { id: this.sceneMime } }).icon;
        } else {
            this.blockIcon = getFontIcons({ $: { id: i_blockPlayerId } }).icon;
        }
        this.blockMimeName = getFontIcons({ $: { id: i_blockPlayerId } }).name;
        this.blockVideoLinkName = this.storeSelector.getBlockLabelById(this.sceneSlice.sceneItem.$.player).name;
        // this.blockMimeName = i_blockPlayerId.replace(/Json./ig, '').toLowerCase();
        // this.blockMimeName = this.blockMimeName.charAt(0).toUpperCase() + this.blockMimeName.slice(1);
    }

    toggleMinimize() {
        if (!this.sidenav.opened) {
            const container = document.querySelector(".list-container.main-container");
            if (container) {
                super.toggleSlide(container.clientWidth);
            }
        }
        this.sidenav.toggle();
        this.cd.detectChanges();

        // setTimeout(() => {  // used to prevent toolbar broken style
        //     this.propsMinimized = propsMinimized;
        // });
    }

    backSceneList() {
        // if (this.saveMode.saveSceneOnExit) {
        //     this.onSave(() => {}, false);
        // }
        this.containerService.setMarkedTableRow(this.selectedSceneId);
        this.router.navigateByUrl("/editor/list");
    }

    private setBlockJsonBased() {
        const blockLabelProps: IBlockLabelProp = this.storeSelector.getBlockLabelById(this.sceneSlice.sceneItem.$.player);
        this.videoHelp = blockLabelProps.videoHelp;
        this.blockJsonBased = blockLabelProps.types.length > 0 && blockLabelProps?.jsonPlayerBased;
        if (_.isUndefined(this.blockJsonBased)) this.blockJsonBased = false;
    }

    animationDone(e) {
        if (e.toState === "hidden") {
            this.visibility = "visible";
        }
    }

    onClickTab(e) {
        // if (this.sceneButNotNested) {
        //     this.activeTabIndex = e;
        // } else {
        //     this.activeTabIndex = e + 1;
        // }
    }

    // private isDataProvider(sceneItemPlayer) {
    //     if (DataProviderBlocks.findIndex((b) => compareIds(sceneItemPlayer, b.id))) {
    //         return true;
    //     }
    //     return false;
    // }

    toggleTransitions() {
        this.transitionsEnabled = !this.transitionsEnabled;
        this.localStoreService.setStorageValConfig("transitionsEnabled", this.transitionsEnabled);
    }

    onMinimized() {
        this.minimized = true;
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 200);
    }

    onMaximized() {
        this.minimized = false;
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 200);
    }

    setActiveTemplate(templateName: string): void {
        if (this.activeTemplate != templateName) {
            this.onMaximized();
        } else {
            if (this.minimized) {
                this.onMaximized();
            } else {
                this.onMinimized();
            }
        }
        this.activeTemplate = templateName;
    }

    getTemplate(name: string): TemplateRef<any> | null {
        switch (name) {
            case "details":
                return this.detailsTemplate;
            case "animation":
                return this.animationTemplate;
            case "effects":
                return this.effectsTemplate;

            default:
                return null;
        }
    }

    protected override toggleSlideOnResize() {
        this.sidenavMode = "side";
        if (window.innerWidth < this.toggleWidth) {
            this.onMinimized();
        } else {
            this.onMaximized();
        }
    }

    getSelectedItems() {
        if (!this.sceneData || !this.activeIds || this.activeIds.length === 0) {
            return [];
        }

        const players = this.sceneData.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player;
        if (!players) {
            return [];
        }

        return this.activeIds
            .map((activeId) => {
                const player = players.find((p) => compareIds(p.$.id, activeId));
                if (!player) return null;

                const block = this.storeSelector.getBlockLabelById(player.$.player);
                if (!block) return null;

                const blockIcon = getFontIcons({ $: { id: player.$.player } }).icon;
                const itemName = this.getSelectedItemName(player);

                return {
                    id: player.$.id,
                    name: itemName,
                    icon: blockIcon,
                    mimeType: player.$.mimeType || "",
                };
            })
            .filter((item) => item !== null);
    }

    private getSelectedItemName(sceneItem: any): string {
        if (this.storeSelector.isResourceBased(sceneItem.$.player)) {
            const res = this.resources.find((r) => {
                return compareIds(r.resource_id, sceneItem.Data?.["0"]?.Resource?.["0"]?.$?.resource);
            });
            if (res) {
                return res.resource_name;
            } else {
                return sceneItem.$.label;
            }
        } else {
            return sceneItem.$.label;
        }
    }

    deselectAll() {
        // Deselect all items and select the root scene
        if (this.selectedSceneId) {
            this.storeSelector.dispatch(actionSelectedSceneItemId({ id: this.selectedSceneId }));
            this.containerService.activeSceneItemIds.next([this.selectedSceneId]);
        }
    }

    override destroy() {
        super.destroy();
        this.storeSelector.dispatch(actionSelectedSceneItemId({ id: null }));
        this.storeSelector.dispatch(actionSelectedSceneId({ id: null }));
        this.storeSelector.dispatch(actionSceneBreadcrumbsClear());
        this.storeSelector.dispatch(actionSceneJumpLinked({ previousLinkedSceneId: null, previousSlidesSceneId: null }));
        this.storeSelector.dispatch({ type: "CLEAR" });
        this.containerService.updateEditorMode(null);
        this.setTitle(true);
    }
}
